'use client';

import React from 'react';

interface VerificationBadgesProps {
  qrVerified: boolean;
  onSiteVerified: boolean;
}

export default function VerificationBadges({
  qrVerified,
  onSiteVerified,
}: VerificationBadgesProps) {
  return (
    <div className="card-phone p-4">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-widest mb-3">
        Security Verification
      </p>
      <div className="flex flex-col gap-2.5">
        <VerificationBadge
          icon={
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          }
          label="QR code verified"
          sublabel="Token is current and authentic"
          verified={qrVerified}
          verifiedColor="text-primary"
          verifiedBg="verification-badge"
        />
        <VerificationBadge
          icon={
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
          }
          label={onSiteVerified ? 'On-site verification passed' : 'On-site verification pending'}
          sublabel={onSiteVerified ? 'Request originates from TEI network' : 'Network verification not yet configured'}
          verified={onSiteVerified}
          verifiedColor="text-primary"
          verifiedBg="verification-badge"
        />
      </div>
    </div>
  );
}

function VerificationBadge({
  icon,
  label,
  sublabel,
  verified,
  verifiedColor,
  verifiedBg,
}: {
  icon: React.ReactNode;
  label: string;
  sublabel: string;
  verified: boolean;
  verifiedColor: string;
  verifiedBg: string;
}) {
  return (
    <div className={`flex items-center gap-3 px-3.5 py-2.5 rounded-lg transition-all duration-300 ${
      verified ? verifiedBg : 'verification-badge-pending'
    }`}>
      <div className={`flex-shrink-0 ${verified ? verifiedColor : 'text-accent'}`}>
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-semibold leading-tight ${verified ? 'text-foreground' : 'text-muted-foreground'}`}>
          {verified ? '✓ ' : '⏳ '}{label}
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">{sublabel}</p>
      </div>
      {verified && (
        <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
      )}
    </div>
  );
}